angular.module('note')
    .component('noteShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/note/show.html',
        controller: function ($scope, $state, $stateParams, $window, NoteService, Principal) {
            this.NoteService = NoteService;
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);

            this.cancel = () => $window.history.back();
            $scope.$on('note.updated', () => $state.go("noteList", $stateParams));
            $scope.$on('note.deleted', () => $state.go("noteList", $stateParams));
        }
    })
    .controller('NoteShowDialogController', function ($scope, $uibModalInstance, data, Note, NoteService, Principal) {
        this.NoteService = NoteService;
        this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);

        this.$onInit = () => {
            Note.get({id: data.id}).$promise
                .then(result => {
                    this.item = result;
                })
                .catch(() => this.cancel());
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.$on('note.updated', () => this.$onInit());
        $scope.$on('note.deleted', () => this.cancel());
    })
